/**
 * S-Pankki's spacings as defined at:
 * https://www.figma.com/design/OwOoUoLpXYwwL9BIgxfT6l/%F0%9F%91%BE-%233---COOKBOOK-(Brand-renewal%3A-component-library)?node-id=5756-5248&t=3yaCyCxeimZeVWW3-0
 */
export const LEGACY_SPACE_XLARGE = '3.5rem' // 56px
